<template>
    <nav class="breadcrumb has-succeeds-separator is-right" aria-label="breadcrumbs">
    <ul>
        <li :class="{'is-active':!item.active}" v-for="(item,n) in data" :key="n">
            <router-link :to="item.link">
                <span class="icon is-small has-text-white">
                    <fa :icon="item.icon" />
                </span>
                <span class="has-text-white is-uppercase">{{item.name}}</span>
            </router-link>
        </li>
    </ul>
    </nav>
</template>

<script>
export default {
    name:'DefaultBreadCrumb',
    props: {
        data: {
            type:Array,
            default: ()=>([])
        }
    }
}
</script>

<style>

</style>